import { LoginSource } from "healthex-common/heap.dtos";
import { getObservableT } from "../Infra/i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
import { PatientLandingViewModel } from "./PatientLandingViewModel";
const t = getObservableT("patients");
export class PatientLandingEmailCollectionViewModel extends PatientLandingViewModel {
    constructor(container) {
        var _a;
        super(container);
        this.formModel = new FormModel({
            email: "",
        }, []);
        this.formModel.input.email = (_a = this.patientConsentUIManager.patientCollectedEmail) !== null && _a !== void 0 ? _a : "";
    }
    validateInput() {
        const { notBlank, validEmail } = validators;
        const f = this.formModel;
        f.clearErrors();
        f.validateField("email", notBlank, t("Enter an email address"));
        f.validateField("email", validEmail, t("Enter a valid email address"));
        return !f.hasErrors();
    }
    async continue() {
        if (!this.organization || this.organization === NOT_LOADED)
            return;
        if (!this.validateInput())
            return;
        this.patientConsentUIManager.updatePatientCollectedEmail(this.formModel.input.email);
        await this.clearAuthManager.redirectToClearLoginPage(window.location.hash, LoginSource.USER_LOGIN, this.organization.id, false, this.isSandboxLogin, this.patientConsentUIManager.patientCollectedEmail, this.patientConsentUIManager.currentLanguage);
    }
}
